export default {
	// ko-KR.js
	security: {
		securityBind: "보안 바인딩",
		securitySettings: "보안 설정",
		level: "중간",
		confirm: "확인",
		submitting: "제출 중...",
		add: "추가",
		change: "변경",
		success: "성공적으로 업데이트되었습니다",
		select: "선택",

		birthday: "연락처 생일",
		birthdayDesc: "더 쉬운 소통을 위해 연락처 생일을 등록하세요. 개인 정보는 안전하게 보호됩니다.",
		month: "월",
		day: "일",
		year: "년",
		birthdayRequired: "생일은 필수입니다.",
		invalidBirthday: "유효하지 않은 생일입니다.",
		invalidMonth: "유효하지 않은 월입니다.",
		invalidDay: "유효하지 않은 일입니다.",
		invalidYear: "유효하지 않은 년도입니다.",
		updateBirthdayFail: "생일 업데이트에 실패했습니다",
		birthdayVerify: "생일 바인딩 인증",
		birthdayVerifyDesc: "계정 보안을 강화하기 위해 생일을 등록하세요.",

		email: "연락처 이메일",
		emailDesc: "계정 보안을 위한 이메일입니다. 본인만 바인딩할 수 있습니다.",
		emailRequired: "이메일은 필수입니다.",
		emailInvalid: "잘못된 이메일 주소입니다.",
		updateEmailFail: "이메일 업데이트에 실패했습니다",
		emailVerify: "이메일 바인딩 인증",
		emailVerifyDesc: "계정 보안을 강화하기 위해 이메일 주소를 인증하세요.",

		phone: "전화번호",
		bindPhone: "전화번호 바인딩",
		phoneDesc: "계정 보안을 위한 전화번호입니다. 본인만 바인딩할 수 있습니다.",
		phoneRequired: "전화번호는 필수입니다.",
		phoneUsed: "다른 전화번호를 사용해 주세요.",
		updatePhoneFail: "전화번호 업데이트에 실패했습니다",
		noCode: "코드를 받지 못하셨나요?",
		smsHelp: "여러 번 시도했지만 인증 코드를 받지 못한 경우.",
		smsTips1: "1. 입력한 휴대폰 번호가 올바른지 확인하세요.",
		smsTips2: "2. 휴대폰 번호가 오래되었는지 확인하세요.",
		smsTips3: "3. 메시지가 SMS 보관함에 있는지 확인하세요.",
		smsTips4: "4. 메시지가 몇 분 정도 지연될 수 있습니다.",
		phoneVerify: "전화번호 바인딩 인증",
		phoneVerifyDesc: "계정 보안을 강화하기 위해 전화번호를 인증하세요.",

		setPassword: "비밀번호 설정",
		passwordDesc: "로그인 비밀번호를 설정하세요.",
		clickSelectBirthday: "클릭하여 생일 선택",
		selectBirthday: "생일 선택",
		confirm: "확인",
		cancel: "취소",
		withdrawPassword: "출금 비밀번호",
		withdrawpasswordDesc: "출금 비밀번호를 설정하세요.",
		set: "설정",
	},

	contactPhone: {
		title: "전화번호 변경",
		titleMobile: "변경",
		description: "더 쉬운 소통을 위해 연락처 전화번호를 추가하세요. 개인정보는 보호됩니다.",
		label: "연락처 전화번호",
		confirm: "확인",
		submitting: "제출 중...",
		required: "전화번호는 필수입니다",
		invalid: "유효하지 않은 전화번호입니다",
		success: "전화번호가 성공적으로 업데이트되었습니다!",
		updateFailed: "업데이트 실패",
		tryAgain: "업데이트에 실패했습니다. 나중에 다시 시도해주세요",
		verifyTitleMobile: "전화번호 인증",
		titleMobile: "전화번호 연동",
		changeTitleMobile: "전화번호 변경",
		securityTip: "계정 보안을 위한 전화번호입니다. 본인만 연동할 수 있습니다.",
		placeholder: "전화번호",
		noCodeReceived: "인증코드를 받지 못하셨나요?",
		codeDescription: "아래 연락처로 전송된 6자리 인증코드를 입력해 주세요:",
		resendIn: "{countdown}초 후 재전송",
		resend: "재전송",
		submitting: "제출 중...",
		confirm: "확인",
		invalidCode: "올바른 6자리 코드를 입력해 주세요",
		required: "전화번호를 입력해 주세요",
		invalid: "올바른 전화번호를 입력해 주세요",
		success: "성공적으로 업데이트되었습니다",
		updateFailed: "업데이트 실패",
		tryAgain: "나중에 다시 시도해 주세요"
	},

	contactEmail: {
		title: "이메일 변경",
		titleMobile: "변경",
		description: "더 쉬운 소통을 위해 연락처 이메일을 추가하세요. 개인정보는 보호됩니다.",
		label: "연락처 이메일",
		placeholder: "이메일",
		confirm: "확인",
		submitting: "제출 중...",
		required: "이메일을 입력해주세요",
		invalid: "유효한 이메일 주소를 입력해주세요",
		success: "이메일이 성공적으로 업데이트되었습니다!",
		updateFailed: "업데이트 실패",
		tryAgain: "업데이트에 실패했습니다. 나중에 다시 시도해주세요",
		verifyTitleMobile: "이메일 인증",
		titleMobile: "이메일 연동",
		changeTitleMobile: "이메일 변경",
		securityTip: "계정 보안을 위한 이메일입니다. 본인만 연동할 수 있습니다.",
		noCodeReceived: "인증코드를 받지 못하셨나요?",
		codeDescription: "아래 연락처로 전송된 6자리 인증코드를 입력해 주세요:",
		resendIn: "{countdown}초 후 재전송",
		resend: "재전송",
		submitting: "제출 중...",
		confirm: "확인",
		invalidCode: "올바른 6자리 코드를 입력해 주세요",
		required: "이메일을 입력해 주세요",
		invalid: "올바른 이메일 주소를 입력해 주세요",
		success: "성공적으로 업데이트되었습니다",
		updateFailed: "업데이트 실패",
		tryAgain: "나중에 다시 시도해 주세요"
	},

	accountInfo: {
		profileInfo: "프로필 정보",
		contactInfo: "연락처 정보",
		privacy: "개인정보 보호",
		contactEmail: "연락처 이메일",
		contactPhone: "연락처 전화번호",
		addEmailDesc: "더 쉬운 소통을 위해 연락처 이메일을 추가하세요. 개인정보는 보호됩니다.",
		addPhoneDesc: "더 쉬운 소통을 위해 연락처 전화번호를 추가하세요. 개인정보는 보호됩니다.",
		hideUsername: "공개 목록에서 내 사용자 이름을 숨기기",
		add: "추가",
		change: "변경",
		idLabel: "ID: ",
		vip: "VIP ",
		player: "플레이어",
		copied: "복사됨!",
		hideSuccess: "사용자 이름 숨김 성공",
		showSuccess: "사용자 이름 표시 성공",
		operationFailed: "작업 실패",
		editProfile: "프로필 수정",
		contactInfo: "연락처 정보",
		contactEmail: "연락처 이메일",
		emailTip: "원활한 소통을 위해 연락처 이메일을 추가하세요. 귀하의 개인 정보는 안전하게 보호됩니다.",
		change: "변경",
		addEmail: "이메일 추가",
		contactPhone: "연락처 전화번호",
		phoneTip: "안전한 계정 인증을 위해 전화번호를 추가하세요.",
		addPhone: "전화번호 추가",
		birthdayBind: "생년월일 연동 인증",
		birthdayTip: "계정 보안을 강화하기 위해 생년월일을 연동하세요.",
		addBirthday: "생년월일 추가",
		personalInfo: "개인 정보",
		personalTip: "본인 인증을 완료하고 더 많은 서비스를 이용해 보세요. 귀하의 데이터는 안전합니다.",
		verifyNow: "지금 인증",
		hideUsernameTip: "활성화하면 다른 사용자가 공개 목록에서 귀하의 사용자 이름을 볼 수 없습니다.",
	},

	kyc: {
		title: "신원 인증",
		verifyIdentity: "신원을 인증하세요",
		completeDesc: "신원 인증을 완료하여 계정을 안전하게 보호하고 모든 기능을 사용하세요.",
		failed: "인증에 실패했습니다. 다시 시도해 주세요.",
		reVerify: "다시 인증",
		checkYouOut: "신원을 인증해 봅시다",
		prepareDoc: "서류를 준비하세요",
		prepareDocDesc: "유효한 신분증을 준비하세요.",
		useSmartphone: "스마트폰 사용",
		useSmartphoneDesc: "인증을 완료하려면 스마트폰이 필요합니다.",
		scanQr: "QR 코드 스캔",
		scanQrDesc: "휴대폰으로 QR 코드를 스캔하여 모바일에서 계속하세요.",
		noSmartphone: "스마트폰이 없으신가요?",
		completeOnMobile: "모바일에서 완료"
	},

	verify: {
		title: "인증",
		personalVerification: "개인 인증",
		weak: "약함",
		level1: "레벨 1",
		personalInfo: "개인 정보",
		personalInfoDesc: "개인 정보를 입력하여 계정 보안을 강화하세요.",
		verifyNow: "지금 인증",
		level2: "레벨 2",
		kycVerification: "KYC 인증",
		kycDesc: "KYC 인증을 완료하여 더 높은 한도와 전체 기능을 이용하세요.",
		docTip: "제출하기 전에 서류가 선명하고 유효한지 확인하세요."
	},

	personalInfo: {
		verify: "인증",
		completeInfo: "정보를 입력하세요",
		completeInfoDesc: "개인 정보를 입력하여 인증을 완료하세요.",
		firstName: "이름",
		paternalSurname: "부계 성",
		maternalSurname: "모계 성",
		contactNumber: "연락처 번호",
		phoneUsed: "이미 사용 중인 전화번호입니다.",
		contactEmail: "연락처 이메일",
		invalidEmail: "잘못된 이메일 주소입니다.",
		detailedAddress: "상세 주소",
		city: "도시",
		street: "거리",
		neighborhood: "동네",
		houseNumber: "집 번호",
		postalCode: "우편번호",
		save: "저장",
		male: "남성",
		female: "여성"
	},

	withdrawPassword: {
		changeTitle: "출금 비밀번호 변경",
		setTitle: "출금 비밀번호 설정",
		changeDesc: "이전 비밀번호를 입력하고 새 출금 비밀번호를 설정하세요.",
		setDesc: "자금을 보호하기 위해 출금 비밀번호를 설정하세요.",
		oldPlaceholder: "이전 출금 비밀번호",
		newPlaceholder: "새 출금 비밀번호",
		confirmPlaceholder: "출금 비밀번호 확인"
	},

	contactBirthday: {
		title: "연락처 생일",
		desc: "더 쉬운 소통을 위해 연락처 생일을 등록하세요. 개인 정보는 안전하게 보호됩니다.",
		label: "연락처 생일",
		invalid: "유효하지 않은 생일입니다."
	},

	changePassword: {
		title: "비밀번호 변경",
		expiredDesc: "비밀번호가 만료되었습니다. 계속하려면 새 비밀번호를 설정하세요.",
		verifyOldDesc: "이전 비밀번호를 입력하고 새 비밀번호를 설정하세요.",
		passwordPlaceholder: "이전 비밀번호",
		newPlaceholder: "새 비밀번호",
		confirmPlaceholder: "새 비밀번호 확인",
		lengthError: "비밀번호는 6~30자여야 합니다.",
		sameAsOld: "새 비밀번호는 이전 비밀번호와 같을 수 없습니다.",
		confirmRequired: "새 비밀번호를 확인해 주세요.",
		notMatch: "비밀번호가 일치하지 않습니다.",
		success: "비밀번호가 성공적으로 변경되었습니다",
		failed: "비밀번호 변경에 실패했습니다"
	},

	settingsNav: {
		title: "설정",
		accountInfo: "계정 정보",
		security: "보안"
	},

	verificationBirthday: {
		title: "생년월일",
		securityTip: "계정 보안을 위한 생년월일입니다. 본인만 연동할 수 있습니다.",
		clickSelectBirthday: "클릭하여 생년월일 선택",
		invalidBirthday: "올바르지 않은 생년월일입니다",
		submitting: "제출 중...",
		confirm: "확인",
		cancel: "취소",
		selectBirthday: "생년월일 선택",
		birthdayRequired: "생년월일을 입력해 주세요",
		updateBirthdayFail: "생년월일 업데이트 실패",
		success: "성공적으로 업데이트되었습니다"
	}
};